export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

import { resolveMaximumFileUploadSize, DEFAULT_MAXIMUM_FILE_UPLOAD_SIZE } from 'shared/helpers/FileHelper';

export const MAXIMUM_FILE_UPLOAD_SIZE = resolveMaximumFileUploadSize(
  window?.globalConfig?.MAXIMUM_FILE_UPLOAD_SIZE || DEFAULT_MAXIMUM_FILE_UPLOAD_SIZE
);

export const ALLOWED_FILE_TYPES =
  'image/*,' +
  'audio/*,' +
  'video/*,' +
  '.3gpp,' +
  'text/csv, text/plain, application/json, application/pdf, text/rtf,' +
  'application/xml, text/xml,' +
  'application/zip, application/x-7z-compressed application/vnd.rar application/x-tar,' +
  'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text,' +
  'application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    value: 5,
    color: '#44CE4B',
  },
];

export const CSAT_DISPLAY_TYPES = {
  EMOJI: 'emoji',
  STAR: 'star',
};

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  MP3: 'audio/mp3',
  WAV: 'audio/wav',
};

export const MESSAGE_VARIABLES = [
  {
    label: 'ID da Conversa',
    key: 'conversation.id',
  },
  {
    label: 'ID do Contato',
    key: 'contact.id',
  },
  {
    label: 'Nome do Contato',
    key: 'contact.name',
  },
  {
    label: 'Primeiro Nome do Contato',
    key: 'contact.first_name',
  },
  {
    label: 'Sobrenome do Contato',
    key: 'contact.last_name',
  },
  {
    label: 'E-mail do Contato',
    key: 'contact.email',
  },
  {
    label: 'Telefone do Contato',
    key: 'contact.phone',
  },
  {
    label: 'Nome do Atendente',
    key: 'agent.name',
  },
  {
    label: 'Primeiro Nome do Atendente',
    key: 'agent.first_name',
  },
  {
    label: 'Sobrenome do Atendente',
    key: 'agent.last_name',
  },
  {
    label: 'E-mail do Atendente',
    key: 'agent.email',
  },
  {
    label: 'Nome da Caixa de Entrada',
    key: 'inbox.name',
  },
  {
    label: 'ID da Caixa de Entrada',
    key: 'inbox.id',
  },
  // Kanban-specific variables
  {
    label: 'Título do Item Funil',
    key: 'item_details.title',
  },
  {
    label: 'Descrição do Item Funil',
    key: 'item_details.description',
  },
  {
    label: 'Valor do Item Funil',
    key: 'item_details.value',
  },
  {
    label: 'Prioridade do Item Funil',
    key: 'item_details.priority',
  },
  {
    label: 'Nome do Funil',
    key: 'funnel.name',
  },
  {
    label: 'Nome da Etapa do Funil',
    key: 'funnel.stage_name',
  },
];

export const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
};

export const TWILIO_CONTENT_TEMPLATE_TYPES = {
  TEXT: 'text',
  MEDIA: 'media',
  QUICK_REPLY: 'quick_reply',
  CALL_TO_ACTION: 'call_to_action',
};
